import { createSlice } from "@reduxjs/toolkit";
import { NotificationType } from "constants/SiteConstants";

const initialState = {
  type: "",
  message: "",
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    notifyError(state, action) {
      state.type = NotificationType.Error;
      state.message = action.payload;
    },
    notifySuccess(state, action) {
      state.type = NotificationType.Success;
      state.message = action.payload;
    },
    closeNotification(state) {
      state.type = "";
      state.message = "";
    },
  },
});

export const {
  notifyError,
  notifySuccess,
  closeNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;
